import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { ItemComponentStore, WireItemEntity } from 'products-data';
import { ItemComponentBase } from '../../../ItemComponentBase';
import { WireCutItemDescriptionViewComponent } from './views/wire-cut-item-description-view/wire-cut-item-description-view.component';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'ideal-wire-cut-item-description',
  imports: [WireCutItemDescriptionViewComponent, JsonPipe],
  standalone: true,
  templateUrl: './wire-cut-item-description.component.html',
  styleUrl: './wire-cut-item-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemComponentStore],
})
export class WireCutItemDescriptionComponent extends ItemComponentBase {
  private readonly _itemDetailsComponentStore = inject(ItemComponentStore);
  protected readonly item = computed(() => this._itemDetailsComponentStore.itemDetails() as WireItemEntity | undefined);

  constructor() {
    super();
    effect(() => this._itemDetailsComponentStore.setItemId(this.id()));
  }
}
